import React, { useState } from "react";
import cn from "helpers/classnames";
import Input from "components/shared/Input";
import LcFetch from "lib/shared/fetch";

export default function RequestQuoteForm() {
  const [email, setEmail] = useState("");
  const [groupDescription, setGroupDescription] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [emailError, setEmailError] = useState(null);
  const [groupDescriptionError, setGroupDescriptionError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setEmailError(null);
    setGroupDescriptionError(null);

    let isValid = true;

    // Email validation
    // 1. It can't be blank
    // 2. It must be a valid email format
    if (email.trim() === "") {
      setEmailError("Email can't be blank");
      isValid = false;
    } else {
      const emailPattern = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
      if (!emailPattern.test(email)) {
        setEmailError("Email is invalid");
        isValid = false;
      }
    }

    // GroupDescription validation
    // 1. It can't be blank
    if (groupDescription.trim() === "") {
      setGroupDescriptionError("Group description can’t be blank");
      isValid = false;
    }

    if (!isValid) return;

    const response = await LcFetch("/subscription/groups", {
      body: JSON.stringify({ email, group_description: groupDescription }),
      method: "POST"
    });

    if (!response.ok) {
      const data = await response.json();
      if (data.errors) {
        if (data.errors.email)
          setEmailError(
            Array.isArray(data.errors.email)
              ? data.errors.email[0]
              : data.errors.email
          );
        if (data.errors.group_description)
          setGroupDescriptionError(
            Array.isArray(data.errors.group_description)
              ? data.errors.group_description[0]
              : data.errors.group_description
          );
      }
    } else {
      resetForm();
      setSubmitted(true);
    }
  };

  const resetForm = () => {
    setEmail("");
    setGroupDescription("");
    setEmailError(null);
    setGroupDescriptionError(null);
    setSubmitted(false);
  };

  return !submitted ? (
    <div
      className={cn(
        "tw-min-h-[328px] tw-flex tw-w-full tw-max-w-[400px] tw-flex-col",
        "tw-pt-3 tw-pr-4 tw-pb-4 tw-pl-4 tw-z-10",
        "md:tw-pt-4 md:tw-pr-5 md:tw-pb-5 md:tw-pl-5",
        "tw-bg-white tw-shadow-[0px_2px_10px_0px_rgba(24,25,25,0.25)] tw-rounded-xl"
      )}
    >
      <form
        className="quote-form tw-w-full tw-flex tw-flex-col tw-text-left"
        onSubmit={handleSubmit}
      >
        <div className="body-2 tw-mb-3">
          <Input
            inputId="email"
            // Normally we would have type="email" here, but we want to use
            // our own validation logic.
            type="text"
            name="email"
            labelText="Email*"
            errorMessage={emailError}
            inputClass="input-lg tw-w-full"
            value={email}
            labelClass="tw-flex body-2 tw-mb-0"
            handleChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="body-2 tw-mb-5">
          <Input
            labelClass="tw-flex body-2"
            labelText="Group description*"
            InputComponent="textarea"
            inputId="group-description"
            name="group-description"
            inputClass="input-lg !tw-h-[104px] tw-w-full tw-resize-y"
            placeholder="E.g., number of teachers and students or any other details about your group"
            value={groupDescription}
            errorMessage={groupDescriptionError}
            handleChange={(e) => setGroupDescription(e.target.value)}
          />
        </div>

        <button
          data-amplitude="submitQuoteForm"
          type="submit"
          className="btn btn-primary btn-lg tw-w-full"
        >
          Submit
        </button>
      </form>
    </div>
  ) : (
    <div
      className={cn(
        "tw-flex tw-h-[328px] tw-max-w-[400px] tw-flex-col tw-items-center tw-justify-center tw-bg-white",
        "tw-z-10 tw-rounded-[12px] tw-shadow-[0px_2px_10px_0px_rgba(24,25,25,0.25)] tw-p-[15px] tw-text-center"
      )}
    >
      <h2 className="title-2 tw-text-teal tw-mb-1 tw-mt-0">Thank you!</h2>
      <p className="body-2 tw-mb-4">
        We have received your request. A member of our team will respond in 1–2
        business days.
      </p>
      <button
        data-amplitude="requestAnotherQuote"
        type="button"
        onClick={resetForm}
        className={cn("btn btn-default btn-lg")}
      >
        Request another quote
      </button>
    </div>
  );
}
